import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarCardComponent } from './calendar-card/calendar-card.component';
import { SharedModule } from '@shared//modules/shared.module';
import { MonthlyTotalsInfoDialogComponent } from './calendar-card/monthly-totals-info-dialog/monthly-totals-info-dialog.component';
import { ActivityDescriptionDialogComponent } from './calendar-card/activity-description-dialog/activity-description-dialog.component';
import { FlightSearchComponent } from './flight-search/flight-search.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LookupSeqComponent } from './flight-search/lookup-seq/lookup-seq.component';
import { SavedFlightsComponent } from './calendar-card/saved-flights/saved-flights.component';

@NgModule({
  declarations: [
    CalendarCardComponent,
    FlightSearchComponent,
    LookupSeqComponent,
    MonthlyTotalsInfoDialogComponent,
    ActivityDescriptionDialogComponent,
    SavedFlightsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FullCalendarModule,
    SharedModule,
  ],
  exports: [
    CalendarCardComponent,
    FlightSearchComponent,
    LookupSeqComponent,
    SavedFlightsComponent,
  ],
})
export class CalendarModule {}
